interface ScoreComparisonTableProps {
  // candidateScores is keyed by `continuityId` so scores follow the dimension
  // across blueprint edits.
  dimensions: { id: string; continuityId: string; name: string; idealScore: number | null }[];
  candidateName: string;
  candidateScores: Record<string, number>;
}

export function ScoreComparisonTable({
  dimensions,
  candidateName,
  candidateScores,
}: ScoreComparisonTableProps) {
  const hasBestFit = dimensions.some((d) => d.idealScore != null);

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b border-border">
            <th className="pb-2 pr-3 text-left font-medium text-text-muted" />
            {dimensions.map((d) => (
              <th
                key={d.id}
                className="pb-2 text-center font-medium text-text-muted"
                style={{ minWidth: 60 }}
              >
                {d.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {hasBestFit && (
            <tr className="border-b border-border">
              <td className="py-1.5 pr-3 font-bold text-text-secondary">BEST FIT</td>
              {dimensions.map((d) => (
                <td key={d.id} className="py-1.5 text-center font-medium text-text-secondary">
                  {d.idealScore ?? "-"}
                </td>
              ))}
            </tr>
          )}
          <tr className="border-b border-border">
            <td className="py-1.5 pr-3 font-medium text-text-secondary">{candidateName}</td>
            {dimensions.map((d) => {
              const score = candidateScores[d.continuityId];
              return (
                <td key={d.id} className="py-1.5 text-center font-medium text-text-primary">
                  {score ?? "-"}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
